import TinyStore from 'lib/tinyStore';
import { Channel } from 'types/common';

type Modal = {
    data: Channel[];
    loading: boolean;
};

const Store = TinyStore.createStore<Modal>({
    nameSpace: 'klarity',
    key: 'listed-channel-hook',
    crossBundle: false,
    runTime: true,
    initValue: { data: [], loading: false },
});

export default Store;
